import React, { ReactNode, useRef } from 'react';

import Carousel from '../Carousel';
import CarouselButtons from './CarouselButtons';

const CSS = require('./CarouselWithButtons.module.scss');

interface CarouselWithButtonsProp {
  as?: 'ul' | 'ol';
  className?: any;
  children: ReactNode;
  viewAllButton?: any;
  variant?: 'light' | 'dark';
  snapMode?: 'horizontal' | 'vertical' | 'none';
}

function CarouselWithButtons({
  as = 'ul',
  className,
  children,
  viewAllButton,
  variant,
  snapMode,
}: CarouselWithButtonsProp) {
  const carouselRef = useRef<HTMLOListElement | HTMLUListElement>(null);

  return (
    <div className={CSS.CarouselContainer} aria-live="off">
      <Carousel
        as={as}
        className={className}
        ref={carouselRef}
        snapMode={snapMode}
      >
        {children}
      </Carousel>
      <nav className={CSS.ButtonContainer}>
        {viewAllButton}
        <CarouselButtons carouselRef={carouselRef} variant={variant} />
      </nav>
    </div>
  );
}

export default CarouselWithButtons;
